import { useQuery, type UseQueryOptions } from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import type {
  DonationPageDto,
  QueryParamsDto,
  ResponseDto,
} from "@mimber/schema"
import { donationsKeys } from "../donations.utils"

export const useDonationPages = (
  params?: QueryParamsDto,
  options?: UseQueryOptions<ResponseDto<DonationPageDto[]>, Error>
) => {
  guardAppUsage("mimber-organization", "useDonationPages")

  const { server } = useServerContext()

  return useQuery<ResponseDto<DonationPageDto[]>, Error>({
    queryKey: donationsKeys.findPages(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<DonationPageDto[]>>(
        buildQueryString("donations/pages", params)
      )
      return response.data
    },
    ...options,
  })
}
